import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/pro-solid-svg-icons'

import {
  Box, Checkbox, ListItem, Text,
} from '@domain-group/suit-theme'

import { toggleArray } from '@domain-group/javascript-utils'

import type { UseAgencyPayload } from '@hooks/useAgency'

import type { ServiceProductModel } from '@models/types'

import handleCallbackAction from '@functions/handleCallbackAction'

type UpdateHiddenProductIdsParams = {
  hiddenProductIds: number[],
  productId: number,
  updateAgencyFn: UseAgencyPayload['callbacks']['updateAgency'],
}

const updateHiddenProductIds = (params: UpdateHiddenProductIdsParams) => {
  const {
    hiddenProductIds, productId, updateAgencyFn,
  } = params

  const updatedHiddenProductIds = toggleArray(hiddenProductIds, productId)

  const updateAgencyOptionsPayload = {
    callbacks: {
      action: updateAgencyFn,
    },
    entityParams: { options: { hidden_product_ids: updatedHiddenProductIds } },
    toastText: 'Agency Options Updated',
  }

  // @ts-expect-error TS2345
  return handleCallbackAction(updateAgencyOptionsPayload)
}

interface ProductListItemProps {
  hiddenProductIds: number[],
  serviceProduct: ServiceProductModel,
  updateAgency: UseAgencyPayload['callbacks']['updateAgency'],
}

const ProductListItem = (props: ProductListItemProps) => {
  const {
    hiddenProductIds,
    serviceProduct,
    updateAgency,
  } = props

  const { title, id, reference_title } = serviceProduct

  const isHidden = hiddenProductIds?.includes(id) || false
  const fontColorStyle = !isHidden ? 'bodyFontLightColor' : 'lightGrey'

  return (
    // @ts-expect-error TS2339
    <ListItem.WithCheckbox
      boxProps={{
        alignItems: 'center',
        borderBottom: '1px dashed',
        borderColor: 'lineColor',
        paddingX: 'large',
        paddingY: 'small',
      }}
      checkbox={(
        <Checkbox
          checked={!isHidden}
          onClick={() => {
            updateHiddenProductIds({
              hiddenProductIds, productId: id, updateAgencyFn: updateAgency,
            })
          }}
        />
      )}
      disableHover
    >
      <Box alignItems={['flex-start', 'center']} flexDirection={['column', 'row']}>
        <Box flexDirection="column" lineHeight="1.3" marginRight="auto" width="auto">
          <Text fontSize="small">{reference_title || title}</Text>
        </Box>

        <Box justifyContent="flex-end" textAlign="right" width="auto">
          <Text color={fontColorStyle} fontSize="small">
            {!isHidden ? 'Product Visible' : 'Product Hidden'}
          </Text>

          <Text color={fontColorStyle} fontSize="small" marginLeft="medium">
            <FontAwesomeIcon icon={!isHidden ? faEye : faEyeSlash} />
          </Text>
        </Box>
      </Box>
      {/*
     // @ts-expect-error TS2339 */}
    </ListItem.WithCheckbox>
  )
}

export default ProductListItem
